export default __webpack_public_path__ + "static/media/progressBarStep2_horizontal.6fdeb87b.svg";